import { useAppSelector } from '../../redux/hooks'
import { RootState } from '../../redux/store'
import './index.scss'

const Loader = () => {
    const { IsLoading } = useAppSelector((state: RootState) => state.CommonReducer)
    return <>{IsLoading && <div id='loader'></div>}</>
}

export default Loader
